import React, { lazy } from 'react';
import { StarIcon as StarIconLucide } from 'lucide-react';
const testimonials = [{
  quote: "This book took me straight back to the smell of popcorn and the sound of Huey Lewis. It's pure nostalgia.",
  author: 'Kevin R., San Diego, CA',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/sAkrP5KJZPcgvCUSMiV772/1.png'
}, {
  quote: 'Reading this felt like watching the trilogy for the first time again. I had tears in my eyes by Chapter Two.',
  author: 'Laura P., Chicago, IL',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hbJweZwSKdeNkYWbdErmrN/5.png'
}, {
  quote: 'The behind-the-scenes stories made me appreciate just how much heart went into this film.',
  author: 'Brandon T., Orlando, FL',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gHcbDgG51oK7Gh3NjAYGDa/2.png'
}];
export const TestimonialsGridSection = () => {
  return <section className="py-4 md:py-8 bg-bttf-bg relative" data-id="element-523">
      <div className="absolute inset-0 bg-gradient-to-r from-bttf-highlight/10 to-transparent opacity-30" data-id="element-524"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-525">
        <div className="grid grid-cols-3 md:grid-cols-3 gap-2 md:gap-6 max-w-5xl mx-auto" data-id="element-526">
          {testimonials.map((t, index) => <div key={index} className="bg-bttf-bg/80 p-2 md:p-6 rounded-lg border border-bttf-accent/30 shadow-lg backdrop-blur-sm flex flex-col" data-id="element-527">
              <div className="relative mb-2 md:mb-4" data-id="element-528">
                <div className="absolute -inset-1 bg-gradient-main rounded-lg blur-sm opacity-40" data-id="element-529"></div>
                <div className="relative w-full rounded-lg overflow-hidden" style={{
              aspectRatio: '1/1'
            }} data-id="element-530">
                  <img src={t.image} alt={t.author} className="w-full h-full object-cover rounded-lg" width="300" height="300" loading="lazy" decoding="async" data-id="element-531" />
                </div>
              </div>
              <div className="flex gap-0.5 mb-1 md:mb-3" data-id="element-532">
                {[...Array(5)].map((_, i) => <StarIconLucide key={i} className="h-2.5 w-2.5 md:h-4 md:w-4 text-[#FFD300] fill-[#FFD300]" data-id="element-533" />)}
              </div>
              <p className="text-[9px] md:text-base italic text-bttf-text leading-tight md:leading-relaxed mb-1 md:mb-3 font-body flex-1 line-clamp-4" data-id="element-534">
                "{t.quote}"
              </p>
              <p className="text-[8px] md:text-sm font-medium text-bttf-accent font-body leading-tight" data-id="element-535">
                — {t.author}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
};